import { render, staticRenderFns } from "./allocationCreate.vue?vue&type=template&id=708bfd63&"
import script from "./allocationCreate.vue?vue&type=script&lang=js&"
export * from "./allocationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('708bfd63')) {
      api.createRecord('708bfd63', component.options)
    } else {
      api.reload('708bfd63', component.options)
    }
    module.hot.accept("./allocationCreate.vue?vue&type=template&id=708bfd63&", function () {
      api.rerender('708bfd63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/cabinManagement/allocationCreate.vue"
export default component.exports